module.exports = __webpack_public_path__ + "media/images/voiture-54a0088b138551066e115ac51666032a.svg";